import { useQuery } from "react-query";

import { UUID } from "foundation-ts/types";
import { ContactType } from "g1-commons/lib/doxecureTypes";

import { ContactsQueryID } from "@hooks/hooksConstants";
import { getContacts } from "@services/users.service";

const useContacts = (sourceUserID:UUID, contactType:ContactType) => useQuery([ContactsQueryID, contactType], () => getContacts(sourceUserID, contactType));

export default useContacts;
